document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".faq-detail").forEach((details) => {
    details.addEventListener("toggle", function () {
      const plusIcon = this.querySelector(".faq-plus-icon");
      const minusIcon = this.querySelector(".faq-minus-icon");

      if (this.hasAttribute("open")) {
        plusIcon.classList.add('hidden')
        minusIcon.classList.remove('hidden');
      } else {
        plusIcon.classList.remove('hidden');
        minusIcon.classList.add('hidden');
      }
    });
  });


    const collapsibleBlocks = document.querySelectorAll(".custom-collapsible-content-block");

    collapsibleBlocks.forEach((block, index) => {
        const title = block.querySelector(".custom-tiitle-icon-wrap");
        const desc = block.querySelector(".collapse-desc");
        const upIcon = block.querySelector(".chev-up-icon");
        const downIcon = block.querySelector(".chev-down-icon");

        // Set first block open by default
        if (index === 0) {
            desc.classList.remove("hidden");
            upIcon.classList.remove("hidden");
            downIcon.classList.add("hidden");
        } else {
            desc.classList.add("hidden");
            upIcon.classList.add("hidden");
            downIcon.classList.remove("hidden");
        }

        // Add click event listener for toggling
      if (title){
        title.addEventListener("click", function () {
            const isHidden = desc.classList.contains("hidden");

            // Toggle content visibility
            if (isHidden) {
                desc.classList.remove("hidden");
                upIcon.classList.remove("hidden");
                downIcon.classList.add("hidden");
            } else {
                desc.classList.add("hidden");
                upIcon.classList.add("hidden");
                downIcon.classList.remove("hidden");
            }
        });
      }
    });


  
});

